import { render, staticRenderFns } from "./ProductionBatchItem.vue?vue&type=template&id=616bedfe&scoped=true&"
import script from "./ProductionBatchItem.vue?vue&type=script&lang=js&"
export * from "./ProductionBatchItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductionBatchItem.vue?vue&type=style&index=0&id=616bedfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616bedfe",
  null
  
)

export default component.exports